import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { HelperService } from '../../../../services/helper/helper.service';
import { ControlBaseComponent } from '../control/control.component';
import { Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-control-email-input',
  styleUrls: ['./control-email-input.component.scss'],
  templateUrl: './control-email-input.component.html',
})
export class ControlTextEmailComponent extends ControlBaseComponent implements OnChanges {

  @Input()  isDisabled: boolean;
  @Input()  isRequired: boolean;
  @Input()  minLength: number = null;
  @Input()  maxLength: number = null;
  @Input()  placeholder: string;
  @Input()  label: string;
  @Input()  model: any;
  @Input()  bindValue: string;
  @Input()  cssClass: string;
  @Input()  controlName: any;
  @Output() ngModelChange = new EventEmitter();
  @Output() ngValidationError = new EventEmitter();

  constructor(public helperService: HelperService) {
    super(helperService);
  }

  private SearchTimeout;

  private searchDelay = true;

  ngOnChanges(changes: SimpleChanges): void {
      if (!this.maxLength) {
        this.maxLength = 1024;
      }
  }

  onKeyUp() {
    if (this.SearchTimeout) {
      clearTimeout(this.SearchTimeout);
      this.searchDelay = true;
    }
    if (this.searchDelay) {
      this.searchDelay = false;
      this.SearchTimeout = setTimeout(() => {
        this.ModelChange();
      }, 1500);
    }
    return;
  }


  ModelChange() {
    const value = this.model[this.bindValue];

    if (this.minLength
        &&  ( value
              && value.length < this.minLength
              && value.length > 0
            )
      ) {
      this.isValidationError = true;
    } else {
      this.isValidationError = false;
    }

    if (value) {
      const control = new FormControl(value, Validators.email);
      if (control.errors && control.errors?.email === true) {
        this.isValidationError = true;
      }
    }

    if (this.ngModelChange) {
      this.ngModelChange.emit();

    }

    if (this.ngValidationError) {
      this.ngValidationError.emit(this.isValidationError);
    }
  }
}
